import styled from 'styled-components';

/** Any children of this wrapper that have the .appearOnHover className will be hidden until the hover for this wrapper is triggered */

export const AppearOnHoverWrapper = styled.div`
	& .appearOnHover {
		opacity: 0;
		transition: all 0.2s ease-in-out;
	}
	&:hover {
		& .appearOnHover {
			opacity: 1;
		}
	}
`;
